import React, { Component } from 'react';
import styles from './style.module.scss';

export default class TabBar extends Component {
  render() {
    return <div className={styles['tabs']}>{this.props.children}</div>;
  }
}
